module.exports = __webpack_public_path__ + "img/story015.20e4ce28.webp";